import {useGlobalStore} from "@/stores/GlobalStore";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {GeneralOldResponse} from "@/models/api/old/responses";
import AuthService from "@/utilities/services/AuthService";
import jwt_decode from "jwt-decode";
import {useGuestStore} from "@/stores/GuestStore";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import router from "@/router";
import GuestService from "@/utilities/services/GuestService";

/*
    check if user needs to reauthenticate and reroute path to login-page
*/
export default async function reactToRouting ({next, to}:any){
    const globalStore = useGlobalStore();

    if(to.path.toLowerCase().includes("external")){
        const guestStore = useGuestStore();
        const guestService = new GuestService();

        if(NullOrUndefinedHelper(guestStore.token) || NullOrUndefinedHelper(guestStore.ticketGuid)) {
            await router.replace("/logout")
            return;
        }

        const resp = await guestService.getTicketType(guestStore.ticketGuid as string, ErrorLocationType.guest)
        if(resp === null) {
            await router.replace("/logout")
            return;
        }


        return next();
    }


    const authService = AuthService.getDefaultInstance();

    const token = await authService.getAccessToken();
    const user = globalStore.user;

    const resp = new GeneralOldResponse();
    if(token === null || token === undefined || token.match(/^\w*$/) !== null) {
        resp.statusCode = 401;

        await ErrorHandler.handleOldError(resp, ErrorLocationType.login);
    }
    else if(user === null || user === undefined) {
        resp.statusCode = 401;

        await ErrorHandler.handleOldError(resp, ErrorLocationType.login);
    }
    else if((jwt_decode(token) as {exp:number}).exp < Math.floor(Date.now()/1000)){
        resp.statusCode = 401;

        await ErrorHandler.handleOldError(resp, ErrorLocationType.login);
    }

    return next();
}
